import type { RemoveRouteGroupFromPlan } from "./types";

export const removeRouteGroupFromPlan: RemoveRouteGroupFromPlan = ({
  plan,
  groupLabel,
}) => {
  const routeGroups = plan.routeGroups.filter(
    (group) => group.label !== groupLabel,
  );

  return {
    ...plan,
    routeGroups,
  };
};
